import React from "react";
import useForwarderInputState from "../../hooks/useForwarderInputState";
import ForwarderInputStateLabel from "../../states/ForwarderInputStateLabel";
const InputStateCell = ({ forwarderId = void 0, inputId, state = void 0, stateMessage = void 0 }) => {
  var _a, _b;
  const { data } = useForwarderInputState(forwarderId != null ? forwarderId : "", inputId);
  const currentState = (_a = data == null ? void 0 : data.state) != null ? _a : state;
  const currentMessage = (_b = data == null ? void 0 : data.state_message) != null ? _b : stateMessage;
  if (!forwarderId) {
    return /* @__PURE__ */ React.createElement("em", null, "N/A");
  }
  return /* @__PURE__ */ React.createElement(ForwarderInputStateLabel, { state: currentState, stateMessage: currentMessage });
};
export default InputStateCell;
